// @react
import React from 'react'
// @common
import DocumentTitle from 'react-document-title'
// @components
import PageTitle from '@bit/atd.web.page-title'
import PageWrapper from 'modules/activityHistory/components/PageWrapper'
import Courses from 'modules/activityHistory/components/Courses'
import Certifications from 'modules/activityHistory/components/Certifications'
import Webinars from 'modules/activityHistory/components/Webinars'
import Conferences from 'modules/activityHistory/components/Conferences'
import Spacer from '@bit/atd.web.spacer'
import { ReactElement } from 'react'

/**
 * 4.0.1 MyATD - Activity History - Learning
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=866%3A3045
 */

const title = 'Learning'

const Learning = (): ReactElement => {
  /******************************************
   * RENDER
   ******************************************/
  return (
    <PageWrapper>
      <DocumentTitle title={`${title} | ATD`}>
        <>
          <PageTitle>Learning</PageTitle>
          <Courses />
          <Spacer size={20} />
          <Certifications />
          <Spacer size={20} />
          <Conferences />
          <Spacer size={20} />
          <Webinars />
          <Spacer size={20} />
        </>
      </DocumentTitle>
    </PageWrapper>
  )
}

export default Learning
